import { PageViewEvent } from '@shopify/events';
import { onDocumentReady } from '@theme/utilities';

onDocumentReady(
  function dispatchPageViewEvent() {
    /** @type {HTMLElement | null} */
    const templateElement = document.querySelector('main[data-template]');
    const template = templateElement?.dataset.template || '';

    // -- Page --
    document.dispatchEvent(
      new PageViewEvent({
        page: {
          template,
          title: document.title,
          url: window.location.href,
        },
      })
    );
  },
  { once: true }
);

onDocumentReady(
  function updateClientPortalMembershipLink() {
    const membershipLink = document.querySelector('.tae-dashboard-card__membership-link');
    if (!membershipLink) return;

    membershipLink.setAttribute(
      'href',
      'https://account.theamenityedit.com/pages/6971b1a1-27f6-4c27-b8b0-3009fd3b921d'
    );
  },
  { once: true }
);
